// https://github.com/reactjs/redux/issues/99
// import { canUseDOM } from 'exenv';

export default function(state = {}, action) {
  const typeMap = {
    POST_AFTERBODY_RECIRC_MODULE_TYPE_LOADING() {
      return {
        isLoading: true,
        postAfterbodyRecircModule: action.postAfterbodyRecircModule
      };
    },
    POST_AFTERBODY_RECIRC_MODULE_TYPE_LOADED() {
      return {
        isLoading: false,
        data: action.postAfterbodyRecircModule
      };
    },
    POST_AFTERBODY_RECIRC_MODULE_TYPE_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.postAfterbodyRecircModule.errorMessage
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
}
